/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FacilityViewModel } from './FacilityViewModel'; 

export function getFacilityOptions(id: string, onSuccess?: (result: FacilityViewModel) => void) {
	return queryOptions({
		queryKey: ['facility', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/facilities/queries/getfacility/' + id;
			const resp = await axios.get<FacilityViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}